import { Controller } from 'stimulus';

export default class StickyBarController extends Controller {
  yMin = null;

  yMax = null;

  lastScrollPosition = window.pageYOffset;

  visibleScrolled = false;

  onScroll = () => {
    if (this.yMin === null || this.yMax === null) {
      return;
    }

    window.cancelAnimationFrame(this.raf);
    this.raf = window.requestAnimationFrame(() => {
      const currentScrollPosition = window.pageYOffset;
      const scrollingUp = this.lastScrollPosition > currentScrollPosition;
      const scrolled = currentScrollPosition >= this.yMax;
      this.lastScrollPosition = currentScrollPosition;

      if (scrollingUp) {
        this.element.style.transform = '';
        this.visibleScrolled = scrolled;
      } else {
        const delta = Math.min(
          Math.max(currentScrollPosition - this.yMin, 0),
          this.yMax - this.yMin,
        );
        Object.assign(this.element.style, {
          transition: this.visibleScrolled ? '' : 'none',
          transform: `translateY(-${delta}px)`,
        });
        if (!this.visibleScrolled) {
          /* eslint-disable no-unused-expressions */
          this.element.offsetWidth;
          this.element.style.transition = '';
        }
      }
    });
  };

  onResize = () => window.requestAnimationFrame(() => {
    this.element.style.position = 'static';
    this.yMin = this.element.offsetTop;
    this.yMax = this.yMin + this.element.offsetHeight;
    this.element.style.position = '';
  });

  connect() {
    this.lastScrollPosition = window.pageYOffset;
    window.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.onResize);
    window.addEventListener('load', this.onResize);
    this.onResize();
    window.requestAnimationFrame(this.onScroll);
  }

  disconnect() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('load', this.onResize);
  }
}
